<template>
  <div style="background-color: #f6f6f6;">
    <van-nav-bar title="我的钱包" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="item" v-for="item in list" :key="item.id" v-on:click="$toast(item.reason)">
        <div class="title">
          <div class="title">{{item.create_time}}</div>
          <div class="price">¥ {{item.amount}}</div>
        </div>
        <div class="content">{{item.reason}}</div>
      </div>
    </van-list>
    <div style="height:46px"></div>
    <TabBar active="4" />
  </div>
</template>
<script>
import TabBar from "@/components/TabBar.vue";
export default {
  name: "money",
  components: {
    TabBar
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      cPage: 1,
      user: { token: "", user: {} }
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onLoad() {
      this.$http
        .get(this.GLOBAL.API + "s_user/balance/record?page=1", {
          params: { cid: 1, page: this.cPage },
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          this.loading = false;
          if (this.cPage >= data.data.last_page) {
            this.finished = true;
          } else {
            this.cPage++;
          }
          if (data.code == 1) {
            this.list = this.list.concat(data.data.data); //= data.data.data;
          }
        });
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
  }
};
</script>
<style lang="scss" scoped>
.list {
  text-align: left;
  .item {
    background-color: #fff;
    padding: 10px 10px 0 10px;
    margin-top: 10px;
    .title {
      display: flex;
      justify-content: space-between;
      .title {
        line-height: 20px;
        height: 40px;
        overflow: hidden;
        padding: 0 5px 0 5px;
      }
      .price {
        color: red;
        text-align: right;
        padding: 0 5px 0 5px;
      }
    }
    .content {
      padding: 0 10px 10px 10px;
    }
  }
}
</style>